export default __webpack_public_path__ + "static/media/Footpad's Leggings of the Burning Temple.4b45cdbb.jpg";